// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Comments-cls1___cd25049a864b01b3cf7{/*!*/}.Comments-cls2___674cabe58c3a7275ca0{position:absolute;left:16px;top:0;bottom:0;border-left:1px solid #dddde2;border-left:1px solid var(--stroke-light, #dddde2)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Comments-cls1___cd25049a864b01b3cf7",
	"cls2": "Comments-cls2___674cabe58c3a7275ca0 Comments-cls1___cd25049a864b01b3cf7"
};
export default ___CSS_LOADER_EXPORT___;
